(function () {
  'use strict';
  function initWidget(widget) {
    if (widget.dataset.psBundleReady === 'true') return;
    var packages = Array.from(widget.querySelectorAll('.package-option'));
    if (!packages.length) return;
    var data = widget.querySelector('script[type="application/json"]');
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    var scope = widget.closest('[id^="shopify-section-"]') || document;
    var form = widget.querySelector('form[action$="/cart/add"]') || scope.querySelector('form[action$="/cart/add"]');
    if (!form) return;
    widget.dataset.psBundleReady = 'true';
    var qtyInput = form.querySelector('input[name="quantity"]');
    var variantInput = form.querySelector('input[name="id"]');
    var variantPicker = scope.querySelector('.product-detail__variant-picker');
    var variantSection = widget.querySelector('.vdb-variant-section');
    var variantFields = widget.querySelector('.vdb-variant-selectors');
    var mixVariants = widget.dataset.enableVariantSelection === 'true';
    var summary = widget.querySelector('[data-ps-bundle-selection]');
    var currency = widget.dataset.currency || 'AUD';
    var blockId = widget.dataset.blockId;
    var selectedQty = 1;
    var selectedVariantIds = [];
    var currentVariant = variants.find(function (v) { return variantInput && String(v.id) === variantInput.value; }) || variants[0];
    var busy = false;
    var settingQuantity = false;
    var baseButtonLabel;
    var unit = widget.dataset.unit || (summary && summary.dataset.unit) || 'item';
    var unitPlural = widget.dataset.unitPlural || (unit === 'pouch' ? 'pouches' : unit === 'box' ? 'boxes' : unit + 's');
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    function money(cents) {
      try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency }).format(cents / 100); }
      catch (_) { return '$' + (cents / 100).toFixed(2); }
    }
    function variantById(id) { return variants.find(function (v) { return String(v.id) === String(id); }); }
    function selectedPackage() { return packages.find(function (p) { return p.classList.contains('selected'); }); }
    function perItem(pkg, variant) {
      variant = variant || currentVariant;
      var base = Number(variant.price) || 0;
      var quote = variant.offer_prices && variant.offer_prices[pkg.dataset.quantity];
      return variant.available && Number.isInteger(quote) && quote >= 0 && quote <= base ? quote : base;
    }
    function quoteKnown(pkg, variant) {
      variant = variant || currentVariant;
      var quote = variant.offer_prices && variant.offer_prices[pkg.dataset.quantity];
      return !!variant.available && (Number(pkg.dataset.quantity) === 1 || Number.isInteger(quote) && quote >= 0 && quote <= Number(variant.price));
    }
    function selectionIds() {
      return mixVariants && selectedQty > 1 ? selectedVariantIds.slice() : Array(selectedQty).fill(String(currentVariant.id));
    }
    function cartItems(ids) {
      var quantities = {};
      ids.forEach(function (id) { quantities[id] = (quantities[id] || 0) + 1; });
      return Object.keys(quantities).map(function (id) { return {id: id, quantity: quantities[id]}; });
    }
    function updateSummary() {
      var pkg = selectedPackage();
      if (!pkg) return;
      var unitPrices = mixVariants && selectedQty > 1
        ? selectedVariantIds.map(function (id) { return perItem(pkg, variantById(id)); })
        : Array(selectedQty).fill(perItem(pkg));
      var total = unitPrices.reduce(function (sum, price) { return sum + price; }, 0);
      var priceConfirmed = selectionIds().every(function (id) { return quoteKnown(pkg, variantById(id)); });
      if (summary) {
        summary.hidden = false;
        summary.querySelector('[data-ps-bundle-quantity]').textContent = selectedQty + ' ' + (selectedQty === 1 ? unit : unitPlural) + ' selected';
        var samePrice = unitPrices.every(function (price) { return price === unitPrices[0]; });
        summary.querySelector('[data-ps-bundle-unit-price]').textContent = samePrice ? ' · ' + money(unitPrices[0]) + ' per ' + unit : ' · ' + unitPrices.map(function (price, index) { return '#' + (index + 1) + ' ' + money(price) + ' per ' + unit; }).join(' · ');
        summary.querySelector('[data-ps-bundle-total]').textContent = money(total) + ' ' + currency;
        summary.querySelector('.ps-bundle-selection__total').firstChild.textContent = priceConfirmed ? 'Bundle total ' : 'Total before bundle savings ';
        summary.dataset.totalCents = String(total);
      }
      var buttonLabel = form.querySelector('.product-form__submit .btn-label');
      if (widget.dataset.updateCartButton === 'true' && buttonLabel && currentVariant.available) {
        baseButtonLabel = baseButtonLabel || buttonLabel.textContent.replace(/\s*[•·\-–—]\s*\$[\d,.]+.*$/i, '').trim();
        buttonLabel.textContent = baseButtonLabel + ' · ' + money(total) + (priceConfirmed ? ' total' : ' total before savings');
      }
      var ids = selectionIds();
      widget.psBundleState = {
        productId: widget.dataset.productId, variantId: String(currentVariant.id),
        variantTitle: currentVariant.title, quantity: selectedQty, totalCents: total,
        unitPriceCents: unitPrices.every(function (price) { return price === unitPrices[0]; }) ? unitPrices[0] : null,
        unitPrices: unitPrices, unit: unit, unitPlural: unitPlural, currency: currency,
        priceConfirmed: priceConfirmed,
        available: ids.length === selectedQty && ids.every(function (id) { var variant = variantById(id); return !!variant && variant.available; }),
        items: cartItems(ids), widgetId: widget.id, formId: form.id
      };
      widget.dispatchEvent(new CustomEvent('ps:bundle:change', {bubbles: true, detail: widget.psBundleState}));
    }
    function updatePrices() {
      var lowestPrice = Math.min.apply(null, packages.filter(function (pkg) { return quoteKnown(pkg); }).map(function (pkg) { return perItem(pkg); }));
      packages.forEach(function (pkg) {
        var price = perItem(pkg);
        var compare = Number(currentVariant.compare_at_price) || 0;
        var priceEl = pkg.querySelector('.discounted-price');
        var compareEl = pkg.querySelector('.regular-price');
        var saveEl = pkg.querySelector('.vdb-package__save-text');
        var confirmed = quoteKnown(pkg);
        pkg.classList.remove('vdb-package--quote-pending');
        pkg.dataset.priceConfirmed = String(confirmed);
        if (priceEl) priceEl.textContent = money(price);
        var note = pkg.querySelector('[data-ps-price-note]');
        if (note) { note.textContent = 'Before bundle savings'; note.hidden = confirmed || Number(pkg.dataset.quantity) === 1; }
        var stock = pkg.querySelector('[data-ps-price-stock]');
        if (stock) stock.hidden = !!currentVariant.available;
        if (compareEl) { compareEl.textContent = money(compare); compareEl.style.display = confirmed && compare > price ? '' : 'none'; }
        var hasSaving = confirmed && compare > price && compare > Number(currentVariant.price);
        if (saveEl) {
          saveEl.textContent = hasSaving ? (widget.dataset.saveLabel || 'SAVE') + ' ' + Math.round((compare - price) / compare * 100) + '%' : '';
          saveEl.parentElement.hidden = !hasSaving;
        }
        var badge = pkg.querySelector('.vdb-package__badge, .badge');
        if (badge) badge.hidden = !confirmed || price >= Number(currentVariant.price) || price > lowestPrice;
      });
      scope.querySelectorAll('[data-ps-tier-product="' + widget.dataset.productId + '"] [data-ps-info-quantity]').forEach(function (tier) {
        var pkg = {dataset: {quantity: tier.dataset.psInfoQuantity}};
        var confirmed = quoteKnown(pkg);
        tier.querySelector('[data-ps-info-price]').textContent = money(perItem(pkg));
        tier.querySelector('[data-ps-price-note]').hidden = confirmed || Number(pkg.dataset.quantity) === 1;
        tier.querySelector('[data-ps-price-stock]').hidden = !!currentVariant.available;
      });
      updateSummary();
    }
    function updateImages() {
      widget.querySelectorAll('.bundle-img[data-image-type]').forEach(function (img) {
        var key = img.dataset.imageType + '_product_image';
        var supplied = currentVariant.metafields && currentVariant.metafields[key];
        // Use the original size/quantity-specific asset whenever Shopify supplies it.
        var src = supplied || currentVariant.featured_image || img.dataset.staticSrc;
        if (src && typeof src === 'object') src = src.src || src.url;
        if (src) { img.src = src; img.alt = (widget.dataset.productTitle || widget.dataset.productHandle.replace(/-/g, ' ')) + (currentVariant.title === 'Default Title' ? '' : ' — ' + currentVariant.title); }
      });
    }
    function setQuantity(qty) {
      selectedQty = qty;
      if (qtyInput) { settingQuantity = true; qtyInput.value = String(qty); qtyInput.dispatchEvent(new Event('change', { bubbles: true })); settingQuantity = false; }
    }
    function buildSelectors(reset) {
      if (!mixVariants || !variantFields || !variantSection) return;
      var previous = reset ? [] : selectedVariantIds.slice();
      variantFields.replaceChildren();
      selectedVariantIds = [];
      variantSection.hidden = selectedQty <= 1;
      if (variantPicker && widget.dataset.hideDefaultVariant === 'true') variantPicker.style.display = selectedQty <= 1 ? '' : 'none';
      if (qtyInput) qtyInput.disabled = selectedQty > 1;
      if (selectedQty <= 1) return;
      variantFields.classList.toggle('vdb-variant-selectors--cols-3', selectedQty >= 3);
      for (var i = 0; i < selectedQty; i++) {
        (function (index) {
          var field = document.createElement('div'); field.className = 'vdb-variant-field';
          var label = document.createElement('label'); label.className = 'vdb-variant-field__label';
          var select = document.createElement('select'); select.className = 'vdb-variant-field__select bundle-select';
          select.id = 'vdb-select-' + blockId + '-' + (index + 1);
          label.htmlFor = select.id; label.textContent = '#' + (index + 1) + ':';
          variants.forEach(function (v) {
            var option = document.createElement('option'); option.value = String(v.id);
            option.textContent = v.title + ' · ' + money(perItem(selectedPackage(), v)) + ' per ' + unit + (!quoteKnown(selectedPackage(), v) ? ' before bundle savings' : '') + (v.available ? '' : ' (Out of stock)'); option.disabled = !v.available;
            select.appendChild(option);
          });
          var previousVariant = variantById(previous[index]);
          var choice = previousVariant && previousVariant.available ? previousVariant : currentVariant;
          // Do not silently replace an explicitly requested, unavailable variant.
          select.value = String(choice.id);
          selectedVariantIds[index] = select.value;
          select.addEventListener('change', function () { selectedVariantIds[index] = select.value; updateSummary(); });
          field.append(label, select); variantFields.appendChild(field);
        })(i);
      }
    }
    function choose(pkg, initial) {
      packages.forEach(function (p) {
        var active = p === pkg; p.classList.toggle('selected', active);
        p.setAttribute('aria-checked', String(active)); p.tabIndex = active ? 0 : -1;
      });
      setQuantity(Number(pkg.dataset.quantity));
      buildSelectors(false);
      if (!initial && summary) summary.querySelector('[data-ps-offer-message]').hidden = true;
      updateSummary();
    }
    var group = packages[0].parentElement;
    group.setAttribute('role', 'radiogroup'); group.setAttribute('aria-label', 'Bundle quantity');
    packages.forEach(function (pkg, index) {
      pkg.setAttribute('role', 'radio');
      pkg.addEventListener('click', function (event) { if (!event.target.closest('select')) choose(pkg, false); });
      pkg.addEventListener('keydown', function (event) {
        if (event.target !== pkg) return;
        if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); choose(pkg, false); }
        var change = ['ArrowRight','ArrowDown'].includes(event.key) ? 1 : ['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 0;
        if (change) { event.preventDefault(); var next = packages[(index + change + packages.length) % packages.length]; choose(next, false); next.focus(); }
      });
    });
    if (qtyInput) {
      var orderedPackages = packages.slice().sort(function (a, b) { return Number(a.dataset.quantity) - Number(b.dataset.quantity); });
      qtyInput.min = orderedPackages[0].dataset.quantity;
      qtyInput.max = orderedPackages[orderedPackages.length - 1].dataset.quantity;
      qtyInput.addEventListener('change', function () {
        if (settingQuantity) return;
        var wanted = Number(qtyInput.value);
        var order = wanted < selectedQty ? orderedPackages.slice().reverse() : orderedPackages;
        var next = order.find(function (pkg) { return wanted < selectedQty ? Number(pkg.dataset.quantity) <= wanted : Number(pkg.dataset.quantity) >= wanted; });
        choose(next || (wanted < selectedQty ? orderedPackages[0] : orderedPackages[orderedPackages.length - 1]), false);
      });
    }
    var params = new URLSearchParams(window.location.search);
    var requestedQty = params.get('ps_quantity');
    var onProduct = window.location.pathname.replace(/\/$/, '').endsWith('/products/' + widget.dataset.productHandle);
    var requested = onProduct && /^\d+$/.test(requestedQty || '') && currentVariant.available
      ? packages.find(function (pkg) { return Number(pkg.dataset.quantity) === Number(requestedQty); }) : null;
    var initial = requested || selectedPackage() || packages[0];
    choose(initial, true); updatePrices(); updateImages();
    if (requested && summary) {
      var message = summary.querySelector('[data-ps-offer-message]');
      message.textContent = 'Your selected offer · ' + currentVariant.title + '. Change the quantity or options below if you prefer.';
      message.hidden = false;
    }
    document.addEventListener('variant:change', function (event) {
      if (!widget.isConnected || !event.detail || !event.detail.variant) return;
      var match = variantById(event.detail.variant.id); if (!match) return;
      currentVariant = Object.assign({}, match, event.detail.variant, {metafields: match.metafields});
      if (Number(currentVariant.price) !== Number(match.price)) currentVariant.offer_prices = {};
      variants[variants.indexOf(match)] = currentVariant;
      if (variantInput) variantInput.value = String(currentVariant.id);
      buildSelectors(true); updatePrices(); updateImages();
      if (summary) summary.querySelector('[data-ps-offer-message]').hidden = true;
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
      if (busy) return;
      var ids = selectionIds();
      if (ids.length !== selectedQty || ids.some(function (id) { var v = variantById(id); return !v || !v.available; })) {
        window.alert('Please choose an available option for each item.'); return;
      }
      var items = cartItems(ids);
      var button = form.querySelector('.product-form__submit');
      busy = true; if (button) { button.disabled = true; button.classList.add('loading'); }
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({items: items})
      }).then(function (response) {
        return response.json().then(function (body) { if (!response.ok) throw new Error(body.description || 'Could not add these items. Please check availability and try again.'); return body; });
      }).then(function () { window.location.href = root + 'cart'; })
        .catch(function (error) { window.alert(error.message || 'Could not add these items. Please try again.'); })
        .finally(function () { busy = false; if (button) { button.disabled = false; button.classList.remove('loading'); } });
    }, true);
    widget.psBundleSubmit = function () { if (!busy) form.requestSubmit(); };
  }
  function boot(root) { (root || document).querySelectorAll('.vdb-widget').forEach(initWidget); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
